import { TagType } from '@app-types/enums/tags';
import { BaseGetRequest } from '@app-types/base/base-get.request';

export interface InsertTagRequest {
  mailAccountId: number;
  tag: string;
  color: string;
  type: TagType;
}

export interface TagContract extends Omit<InsertTagRequest, 'color'> {
  tagId: number;
  color?: string;
}

export type TagList = string[];

export interface ContactTagSaveRequest {
  mailAccountId: number | null;
  contactIds: number[];
  tagIds: number[];
}

export interface EmailTagSaveRequest {
  emailsId: number[];
  tags: TagList;
}

export interface ChangedTags {
  tags: TagContract[];
  ids: number[];
}

export interface ContactTag extends TagContract {
  contactId: number;
}

export class GetByTypeRequest extends BaseGetRequest {
  id: number;
  type: TagType;
  search?: string | null;

  constructor(id: number | null, type: TagType, search?: string | null) {
    super();
    id && (this.id = id);
    type && (this.type = type);
    (search || search === null) && (this.search = search);
  }
}
